import { render, staticRenderFns } from "./FreeOrders.vue?vue&type=template&id=c27cf848&scoped=true&"
import script from "./FreeOrders.vue?vue&type=script&lang=js&"
export * from "./FreeOrders.vue?vue&type=script&lang=js&"
import style0 from "./FreeOrders.vue?vue&type=style&index=0&id=c27cf848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27cf848",
  null
  
)

export default component.exports